import React from 'react'

import RouteLayout from '../../RouteLayout'
import { Buttons, Form, Table } from './Components'
import Spinner from '../../common/Spinner'
import { useSelector } from 'react-redux'


export default function StaffInfo () {

  const { loader, form, data } = useSelector(state => state.reports.staffInfo)

  const hasData = !!(data?.staffing || data?.pedagogical || data?.awards)

  return (
    <RouteLayout title={'Сведения о работниках (форма №3/СВУ)'}>
      <Form form={form}/>
      <Buttons visible={hasData} data={data}/>
      {loader
        ? <Spinner />
        : <Table data={data}/>
      }
    </RouteLayout>
  )
}
